import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;
import * as moment from 'moment';
import { HotelbookingsService } from 'src/app/api/hotelbooking/hotelbookings.service';
import { CalendarOptions } from '@fullcalendar/core';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es'; // ✅ esta ruta sí existe

@Component({
  selector: 'app-hoteltransfers-list',
  templateUrl: './hoteltransfers-list.component.html',
  styleUrls: ['./hoteltransfers-list.component.css']
})
export class HoteltransfersListComponent implements OnInit {
  private thisComponent: HoteltransfersListComponent;
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables
  start_range: any = moment();
  end_range: any = moment().endOf('month');
  date_now: any = moment().format('YYYY-MM-DD');
  totalPaxRecojos: any = 0;
  totalPaxTraslados: any = 0;

  // array values
  existsData: boolean = false;
  recojos: any = { mañana: [], tarde: [], noche: [] };
  traslados: any = { mañana: [], tarde: [], noche: [] };

  constructor(
    private routeActivated: ActivatedRoute,
    private navigationTrackerService: NavigationTrackerService,
    private hotelbookingService: HotelbookingsService,
    private router: Router,
    private elementRef: ElementRef,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.generateCalendar();
    this.list();
    this.navigationTrackerService.initializeMenu(this.routeActivated);
  }

  generateCalendar() {
    let component_ = this.thisComponent;
    (<any>$('#date_range'))
      .daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true,
        startDate: moment().format('YYYY-MM-DD'),
        locale: {
          format: 'YYYY-MM-DD'
        }
      })
      .on('apply.daterangepicker', function(ev: any, picker: any) {
        component_.start_range = picker.startDate;
        component_.existsData = false;
        component_.recojos = {};
        component_.traslados = {};
        component_.list();
      });
  }

  list() {
    const val_params =
      'search=' +
      this.params.search +
      '&page=' +
      this.page +
      '&date_transfer=' +
      this.start_range.format('YYYY-MM-DD');

    this.hotelbookingService.transfers(val_params).subscribe({
      next: (data: any) => {
        this.recojos = { mañana: [], tarde: [], noche: [] };
        this.traslados = { mañana: [], tarde: [], noche: [] };

        const transfers = data.results || [];
        if (transfers.length > 0) {
          this.existsData = true;
          // Función auxiliar para clasificar por turnos
          const getShift = (time: string) => {
            if (!time) return 'SIN HORA';
            const hour = parseInt(time.split(':')[0], 10);

            if (hour < 12) return 'MAÑANA';
            if (hour < 18) return 'TARDE';
            return 'NOCHE';
          };

          const sortByTime = (a: any, b: any) => {
            if (!a.time_transfer) return 1;
            if (!b.time_transfer) return -1;
            return a.time_transfer.localeCompare(b.time_transfer);
          };

          // Agrupar por tipo y por turno
          const groupByShift = (arr: any[]) => {
            return {
              mañana: arr
                .filter(t => getShift(t.time_transfer) === 'MAÑANA')
                .sort(sortByTime),
              tarde: arr
                .filter(t => getShift(t.time_transfer) === 'TARDE')
                .sort(sortByTime),
              noche: arr
                .filter(t => getShift(t.time_transfer) === 'NOCHE')
                .sort(sortByTime)
            };
          };

          // Recojos y traslados separados
          this.recojos = groupByShift(
            transfers.filter((t: any) => t.typetransfer_id == 1)
          );

          this.traslados = groupByShift(
            transfers.filter((t: any) => t.typetransfer_id == 2)
          );

          const sumPax = (group: any) =>
            ['mañana', 'tarde', 'noche']
              .map(shift =>
                group[shift].reduce(
                  (acc: number, item: any) => acc + (item.nro_pax || 0),
                  0
                )
              )
              .reduce((a, b) => a + b, 0);

          this.totalPaxRecojos = sumPax(this.recojos);
          this.totalPaxTraslados = sumPax(this.traslados);

          // console.log('TOTAL PAX RECOJOS:', this.totalPaxRecojos);
          // console.log('TOTAL PAX TRASLADOS:', this.totalPaxTraslados);
        }else{
          this.existsData = false;
        }
      }
    });
  }

  copyToClipboard(book_id: any) {
    let generatedData = this.elementRef.nativeElement.querySelector(
      '#generated-data-' + book_id
    ).innerText;

    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(generatedData)
        .then(() => {
          // console.log('Copied to clipboard');
        })
        .catch(err => {
          console.error('Failed to copy: ', err);
          // Handle clipboard write error (e.g., show error message to user)
        });
    } else {
      // Fallback for browsers that do not support navigator.clipboard
      this.copyFallback(generatedData);
    }
  }

  copyFallback(text: string) {
    // Fallback method for unsupported browsers
    const textarea = document.createElement('textarea');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      document.execCommand('copy');
      // console.log('Copied to clipboard using fallback');
      this.alertifyMsg.success('DATOS COPIADOS');
      // Optionally, provide user feedback (e.g., toast notification)
    } catch (err) {
      console.error('Fallback: Unable to copy to clipboard', err);
      // Handle fallback copy error (e.g., show error message to user)
    } finally {
      document.body.removeChild(textarea);
    }
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  printer() {
    (<any>$('#body')).printThis({
      importCSS: true
    });
  }

  refresh() {
    this.start_range = moment();
    this.existsData = false;
    this.list();
  }
}
